export type LanguageOption = {
  englishLabel: string;
  nativeLabel: string;
  tag: string;
};

export const SUPPORTED_TRANSLATION_LANGUAGE_TAGS = ["de", "en", "es", "fr", "hu"] as const;

type LanguageLabel = {
  englishLabel: string;
  nativeLabel: string;
};

const LANGUAGE_CATALOG: Record<string, LanguageLabel> = {
  // aa: { nativeLabel: "Afar", englishLabel: "Afar" },
  // ab: { nativeLabel: "Abkhazian", englishLabel: "Abkhazian" },
  // ae: { nativeLabel: "Avestan", englishLabel: "Avestan" },
  // af: { nativeLabel: "Afrikaans", englishLabel: "Afrikaans" },
  // ak: { nativeLabel: "Akan", englishLabel: "Akan" },
  // am: { nativeLabel: "አማርኛ", englishLabel: "Amharic" },
  // an: { nativeLabel: "Aragonese", englishLabel: "Aragonese" },
  // ar: { nativeLabel: "العربية", englishLabel: "Arabic" },
  // as: { nativeLabel: "অসমীয়া", englishLabel: "Assamese" },
  // av: { nativeLabel: "Avaric", englishLabel: "Avaric" },
  // ay: { nativeLabel: "Aymara", englishLabel: "Aymara" },
  // az: { nativeLabel: "azərbaycan", englishLabel: "Azerbaijani" },
  // ba: { nativeLabel: "Bashkir", englishLabel: "Bashkir" },
  // be: { nativeLabel: "беларуская", englishLabel: "Belarusian" },
  // bg: { nativeLabel: "български", englishLabel: "Bulgarian" },
  // bh: { nativeLabel: "Bihari", englishLabel: "Bihari" },
  // bi: { nativeLabel: "Bislama", englishLabel: "Bislama" },
  // bm: { nativeLabel: "bamanakan", englishLabel: "Bambara" },
  // bn: { nativeLabel: "বাংলা", englishLabel: "Bangla" },
  // bo: { nativeLabel: "བོད་སྐད་", englishLabel: "Tibetan" },
  // br: { nativeLabel: "brezhoneg", englishLabel: "Breton" },
  // bs: { nativeLabel: "bosanski", englishLabel: "Bosnian" },
  // ca: { nativeLabel: "català", englishLabel: "Catalan" },
  // ce: { nativeLabel: "нохчийн", englishLabel: "Chechen" },
  // ch: { nativeLabel: "Chamorro", englishLabel: "Chamorro" },
  // co: { nativeLabel: "Corsican", englishLabel: "Corsican" },
  // cr: { nativeLabel: "Cree", englishLabel: "Cree" },
  // cs: { nativeLabel: "čeština", englishLabel: "Czech" },
  // cu: { nativeLabel: "Church Slavic", englishLabel: "Church Slavic" },
  // cv: { nativeLabel: "чӑваш", englishLabel: "Chuvash" },
  // cy: { nativeLabel: "Cymraeg", englishLabel: "Welsh" },
  // da: { nativeLabel: "dansk", englishLabel: "Danish" },
  de: { englishLabel: "German", nativeLabel: "Deutsch" },
  // dv: { nativeLabel: "Divehi", englishLabel: "Divehi" },
  // dz: { nativeLabel: "རྫོང་ཁ", englishLabel: "Dzongkha" },
  // ee: { nativeLabel: "eʋegbe", englishLabel: "Ewe" },
  // el: { nativeLabel: "Ελληνικά", englishLabel: "Greek" },
  en: { englishLabel: "English", nativeLabel: "English" },
  // eo: { nativeLabel: "Esperanto", englishLabel: "Esperanto" },
  es: { englishLabel: "Spanish", nativeLabel: "español" },
  // et: { nativeLabel: "eesti", englishLabel: "Estonian" },
  // eu: { nativeLabel: "euskara", englishLabel: "Basque" },
  // fa: { nativeLabel: "فارسی", englishLabel: "Persian" },
  // ff: { nativeLabel: "Pulaar", englishLabel: "Fula" },
  // fi: { nativeLabel: "suomi", englishLabel: "Finnish" },
  // fj: { nativeLabel: "Fijian", englishLabel: "Fijian" },
  // fo: { nativeLabel: "føroyskt", englishLabel: "Faroese" },
  fr: { englishLabel: "French", nativeLabel: "français" },
  // fy: { nativeLabel: "Frysk", englishLabel: "Western Frisian" },
  // ga: { nativeLabel: "Gaeilge", englishLabel: "Irish" },
  // gd: { nativeLabel: "Gàidhlig", englishLabel: "Scottish Gaelic" },
  // gl: { nativeLabel: "galego", englishLabel: "Galician" },
  // gn: { nativeLabel: "Guarani", englishLabel: "Guarani" },
  // gu: { nativeLabel: "ગુજરાતી", englishLabel: "Gujarati" },
  // gv: { nativeLabel: "Gaelg", englishLabel: "Manx" },
  // ha: { nativeLabel: "Hausa", englishLabel: "Hausa" },
  // he: { nativeLabel: "עברית", englishLabel: "Hebrew" },
  // hi: { nativeLabel: "हिन्दी", englishLabel: "Hindi" },
  // ho: { nativeLabel: "Hiri Motu", englishLabel: "Hiri Motu" },
  // hr: { nativeLabel: "hrvatski", englishLabel: "Croatian" },
  // ht: { nativeLabel: "Kreyòl Ayisyen", englishLabel: "Haitian Creole" },
  hu: { englishLabel: "Hungarian", nativeLabel: "magyar" },
  // hy: { nativeLabel: "հայերեն", englishLabel: "Armenian" },
  // hz: { nativeLabel: "Herero", englishLabel: "Herero" },
  // ia: { nativeLabel: "interlingua", englishLabel: "Interlingua" },
  // id: { nativeLabel: "Indonesia", englishLabel: "Indonesian" },
  // ie: { nativeLabel: "Interlingue", englishLabel: "Interlingue" },
  // ig: { nativeLabel: "Igbo", englishLabel: "Igbo" },
  // ii: { nativeLabel: "ꆈꌠꉙ", englishLabel: "Sichuan Yi" },
  // ik: { nativeLabel: "Inupiaq", englishLabel: "Inupiaq" },
  // in: { nativeLabel: "Indonesia", englishLabel: "Indonesian" },
  // io: { nativeLabel: "Ido", englishLabel: "Ido" },
  // is: { nativeLabel: "íslenska", englishLabel: "Icelandic" },
  // it: { nativeLabel: "italiano", englishLabel: "Italian" },
  // iu: { nativeLabel: "Inuktitut", englishLabel: "Inuktitut" },
  // iw: { nativeLabel: "עברית", englishLabel: "Hebrew" },
  // ja: { nativeLabel: "日本語", englishLabel: "Japanese" },
  // ji: { nativeLabel: "ייִדיש", englishLabel: "Yiddish" },
  // jv: { nativeLabel: "Jawa", englishLabel: "Javanese" },
  // ka: { nativeLabel: "ქართული", englishLabel: "Georgian" },
  // kg: { nativeLabel: "Kongo", englishLabel: "Kongo" },
  // ki: { nativeLabel: "Gikuyu", englishLabel: "Kikuyu" },
  // kj: { nativeLabel: "Kuanyama", englishLabel: "Kuanyama" },
  // kk: { nativeLabel: "қазақ тілі", englishLabel: "Kazakh" },
  // kl: { nativeLabel: "kalaallisut", englishLabel: "Kalaallisut" },
  // km: { nativeLabel: "ខ្មែរ", englishLabel: "Khmer" },
  // kn: { nativeLabel: "ಕನ್ನಡ", englishLabel: "Kannada" },
  // ko: { nativeLabel: "한국어", englishLabel: "Korean" },
  // kr: { nativeLabel: "Kanuri", englishLabel: "Kanuri" },
  // ks: { nativeLabel: "کٲشُر", englishLabel: "Kashmiri" },
  // ku: { nativeLabel: "kurdî (kurmancî)", englishLabel: "Kurdish" },
  // kv: { nativeLabel: "Komi", englishLabel: "Komi" },
  // kw: { nativeLabel: "kernewek", englishLabel: "Cornish" },
  // ky: { nativeLabel: "кыргызча", englishLabel: "Kyrgyz" },
  // la: { nativeLabel: "Latin", englishLabel: "Latin" },
  // lb: { nativeLabel: "Lëtzebuergesch", englishLabel: "Luxembourgish" },
  // lg: { nativeLabel: "Luganda", englishLabel: "Ganda" },
  // li: { nativeLabel: "Limburgish", englishLabel: "Limburgish" },
  // ln: { nativeLabel: "lingála", englishLabel: "Lingala" },
  // lo: { nativeLabel: "ລາວ", englishLabel: "Lao" },
  // lt: { nativeLabel: "lietuvių", englishLabel: "Lithuanian" },
  // lu: { nativeLabel: "Tshiluba", englishLabel: "Luba-Katanga" },
  // lv: { nativeLabel: "latviešu", englishLabel: "Latvian" },
  // mg: { nativeLabel: "Malagasy", englishLabel: "Malagasy" },
  // mh: { nativeLabel: "Marshallese", englishLabel: "Marshallese" },
  // mi: { nativeLabel: "Māori", englishLabel: "Māori" },
  // mk: { nativeLabel: "македонски", englishLabel: "Macedonian" },
  // ml: { nativeLabel: "മലയാളം", englishLabel: "Malayalam" },
  // mn: { nativeLabel: "монгол", englishLabel: "Mongolian" },
  // mo: { nativeLabel: "Moldavian", englishLabel: "Moldavian" },
  // mr: { nativeLabel: "मराठी", englishLabel: "Marathi" },
  // ms: { nativeLabel: "Melayu", englishLabel: "Malay" },
  // mt: { nativeLabel: "Malti", englishLabel: "Maltese" },
  // my: { nativeLabel: "မြန်မာ", englishLabel: "Burmese" },
  // na: { nativeLabel: "Nauru", englishLabel: "Nauru" },
  // nb: { nativeLabel: "norsk bokmål", englishLabel: "Norwegian Bokmål" },
  // nd: { nativeLabel: "isiNdebele", englishLabel: "North Ndebele" },
  // ne: { nativeLabel: "नेपाली", englishLabel: "Nepali" },
  // ng: { nativeLabel: "Ndonga", englishLabel: "Ndonga" },
  // nl: { nativeLabel: "Nederlands", englishLabel: "Dutch" },
  // nn: { nativeLabel: "norsk nynorsk", englishLabel: "Norwegian Nynorsk" },
  // no: { nativeLabel: "norsk", englishLabel: "Norwegian" },
  // nr: { nativeLabel: "South Ndebele", englishLabel: "South Ndebele" },
  // nv: { nativeLabel: "Navajo", englishLabel: "Navajo" },
  // ny: { nativeLabel: "Nyanja", englishLabel: "Nyanja" },
  // oc: { nativeLabel: "occitan", englishLabel: "Occitan" },
  // oj: { nativeLabel: "Ojibwa", englishLabel: "Ojibwa" },
  // om: { nativeLabel: "Oromoo", englishLabel: "Oromo" },
  // or: { nativeLabel: "ଓଡ଼ିଆ", englishLabel: "Odia" },
  // os: { nativeLabel: "ирон", englishLabel: "Ossetic" },
  // pa: { nativeLabel: "ਪੰਜਾਬੀ", englishLabel: "Punjabi" },
  // pi: { nativeLabel: "Pali", englishLabel: "Pali" },
  // pl: { nativeLabel: "polski", englishLabel: "Polish" },
  // ps: { nativeLabel: "پښتو", englishLabel: "Pashto" },
  // pt: { nativeLabel: "português", englishLabel: "Portuguese" },
  // qu: { nativeLabel: "Runasimi", englishLabel: "Quechua" },
  // rm: { nativeLabel: "rumantsch", englishLabel: "Romansh" },
  // rn: { nativeLabel: "Ikirundi", englishLabel: "Rundi" },
  // ro: { nativeLabel: "română", englishLabel: "Romanian" },
  // ru: { nativeLabel: "русский", englishLabel: "Russian" },
  // rw: { nativeLabel: "Ikinyarwanda", englishLabel: "Kinyarwanda" },
  // sa: { nativeLabel: "संस्कृत भाषा", englishLabel: "Sanskrit" },
  // sc: { nativeLabel: "sardu", englishLabel: "Sardinian" },
  // sd: { nativeLabel: "سنڌي", englishLabel: "Sindhi" },
  // se: { nativeLabel: "davvisámegiella", englishLabel: "Northern Sami" },
  // sg: { nativeLabel: "Sängö", englishLabel: "Sango" },
  // si: { nativeLabel: "සිංහල", englishLabel: "Sinhala" },
  // sk: { nativeLabel: "slovenčina", englishLabel: "Slovak" },
  // sl: { nativeLabel: "slovenščina", englishLabel: "Slovenian" },
  // sm: { nativeLabel: "Samoan", englishLabel: "Samoan" },
  // sn: { nativeLabel: "chiShona", englishLabel: "Shona" },
  // so: { nativeLabel: "Soomaali", englishLabel: "Somali" },
  // sq: { nativeLabel: "shqip", englishLabel: "Albanian" },
  // sr: { nativeLabel: "српски", englishLabel: "Serbian" },
  // ss: { nativeLabel: "Swati", englishLabel: "Swati" },
  // st: { nativeLabel: "Sesotho", englishLabel: "Southern Sotho" },
  // su: { nativeLabel: "Basa Sunda", englishLabel: "Sundanese" },
  // sv: { nativeLabel: "svenska", englishLabel: "Swedish" },
  // sw: { nativeLabel: "Kiswahili", englishLabel: "Swahili" },
  // ta: { nativeLabel: "தமிழ்", englishLabel: "Tamil" },
  // te: { nativeLabel: "తెలుగు", englishLabel: "Telugu" },
  // tg: { nativeLabel: "тоҷикӣ", englishLabel: "Tajik" },
  // th: { nativeLabel: "ไทย", englishLabel: "Thai" },
  // ti: { nativeLabel: "ትግርኛ", englishLabel: "Tigrinya" },
  // tk: { nativeLabel: "türkmen dili", englishLabel: "Turkmen" },
  // tl: { nativeLabel: "Tagalog", englishLabel: "Tagalog" },
  // tn: { nativeLabel: "Setswana", englishLabel: "Tswana" },
  // to: { nativeLabel: "lea fakatonga", englishLabel: "Tongan" },
  // tr: { nativeLabel: "Türkçe", englishLabel: "Turkish" },
  // ts: { nativeLabel: "Tsonga", englishLabel: "Tsonga" },
  // tt: { nativeLabel: "татар", englishLabel: "Tatar" },
  // tw: { nativeLabel: "Twi", englishLabel: "Twi" },
  // ty: { nativeLabel: "Tahitian", englishLabel: "Tahitian" },
  // ug: { nativeLabel: "ئۇيغۇرچە", englishLabel: "Uyghur" },
  // uk: { nativeLabel: "українська", englishLabel: "Ukrainian" },
  // ur: { nativeLabel: "اردو", englishLabel: "Urdu" },
  // uz: { nativeLabel: "o‘zbek", englishLabel: "Uzbek" },
  // ve: { nativeLabel: "Venda", englishLabel: "Venda" },
  // vi: { nativeLabel: "Tiếng Việt", englishLabel: "Vietnamese" },
  // vo: { nativeLabel: "Volapük", englishLabel: "Volapük" },
  // wa: { nativeLabel: "Walloon", englishLabel: "Walloon" },
  // wo: { nativeLabel: "Wolof", englishLabel: "Wolof" },
  // xh: { nativeLabel: "IsiXhosa", englishLabel: "Xhosa" },
  // yi: { nativeLabel: "ייִדיש", englishLabel: "Yiddish" },
  // yo: { nativeLabel: "Èdè Yorùbá", englishLabel: "Yoruba" },
  // za: { nativeLabel: "Vahcuengh", englishLabel: "Zhuang" },
  // zh: { nativeLabel: "中文", englishLabel: "Chinese" },
  // zu: { nativeLabel: "isiZulu", englishLabel: "Zulu" },
};

export const toLanguageOption = (
  tag: string,
  fallback?: { englishLabel?: string; nativeLabel?: string; }
): LanguageOption => {
  const found = LANGUAGE_CATALOG[tag];

  const nativeLabel = found?.nativeLabel ?? fallback?.nativeLabel;
  const englishLabel = found?.englishLabel ?? fallback?.englishLabel;

  return {
    englishLabel,
    nativeLabel,
    tag
  };
};

export const formatLanguageOptionLabel = (
  tag: string,
  fallback?: { englishLabel?: string; nativeLabel?: string; }
): string => {
  const option = toLanguageOption(tag, fallback);
  const labels = [option.nativeLabel, option.englishLabel].filter(Boolean);
  return labels.join(" / ") || tag;
};

export const parseSupportedTranslationLanguageTag = (value: null | string | undefined): null | string => {
  if (!value) {
    return null;
  }

  const normalized = value.trim().toLowerCase();
  return SUPPORTED_TRANSLATION_LANGUAGE_TAGS.includes(normalized as typeof SUPPORTED_TRANSLATION_LANGUAGE_TAGS[number])
    ? normalized
    : null;
};
